const ContextContent = {
  company: 'Welcome to',
  second: 'Indy Steel Erectors',
  phone: '317.831.8474',
  home: {
    bodyText: [
      `In March of 2008 Indy Steel Erectors became the 2nd steel
      erector in Indiana and the 120th in the United States of America
      to achieve AISC (American Institute of Steel Construction)
      Certified Steel Erector status.`,
      `In April of 2011 we became the 1st erector in Indiana accredited with the
      AISC Advanced Certified Steel Erector. In 2018 Indy Steel Erectors was
      certified under the new AISC standards with endorsements in seismic and
      metal decking.`
    ],
    button: `Who we are`
  },
  who: {
    heading: 'Who we are',
    bodyText: [
      `Indy Steel Erectors was founded in 1980 by three ironworkers and has since evolved into the second oldest steel erection company in the Indianapolis area. The founders set out
      with a goal of creating a family-oriented atmosphere for their ironworkers. This tradition continues today and is evident by the leadership retention averaging over 25 years.`
    ],
    approach: {
      heading: `Differentiated Approach`,
      text: [
        `Plain and simple, we can erect safer and faster than our competition. By retaining leaders, owning our own cranes, and pairing with union iron workers and operating engineers allows us to do so.`,
        `We continue to push the envelope and challenge ourselves constantly in search for new technologies in efficacies regarding safety, quality and production.`
      ]
    },
    inventory: {
      heading: `Equipment Inventory`,
      items: [
        `110 ton Link Belt 218 HSL crawler crane`,
        `75 ton Link Belt TCC-750 telescopic crawler crane`,
        `75 ton Grove 875E rough terrain crane`,
        `28 ton Manitex 30100C boom truck`,
        `10,000 lbs Skytrack 10054 (multiple)`,
        `Miller 400D portable welders (multiple)`
      ]
    },
    goal: {
      heading: `Our Goal`,
      text: [
        `In short, our goal is to maintain a strong dedication to our ironworkers, customers, our relationships, and our reputation. We always make sure to allocate proper
        resources to the three driving factors of our company. SAFETY…QUALITY…PRODUCTION.  We are continuously innovators in the industry.`,
        `We continue to produce quality ironworkers that become leaders, not only for Indy Steel Erectors, but going forward in their futures. And we always produce high quality products.
        By focusing on these main pillars of  Indy Steel Erectors, we have been able to strengthen existing working relationships and cultivate new working relationships. `
      ]
    },
    contractors: {
      heading: `Top notch union contractors`,
      text: [
        `We employ approximately 60 union ironworkers from Indianapolis Local 22. We also employ 5 crane operators from Indianapolis Local 103.`,
        `The advantage of employing union members is to provide skilled craftsmanship and adequate manpower to each project.`
      ]
    }
  },
  what: {
    heading: 'What we do',
    bodyText: [
      `Indy Steel Erectors is an industry leader ensuring that we are the right fit on your next project for
      structural steel and miscellaneous erection. We have cornered the market place because we are able to erect
      small 3-ton projects or larger 3,000 ton projects. Our theory is that everything begins with competitive
      pricing model and understanding a clients’ scope.`,
      `Once a job is booked, we have a simple mind set, “Plan your work, then work your plan.” Our executive team plans
      the projects safety, logistics, sequencing, scheduling and quality. 
      We are always in constant communication with your staff throughout this process, this way a successful plan is developed, followed, and leads to a successful project. If you’re not successful we’re not successful.`
    ],
    markets: {
      heading: `markets served`,
      text: [
        `Indy Steel Erectors performs work within a 100 mile radius of Indianapolis, IN. We erect commercial story buildings,
        hospitals and medical office buildings, small to larger schools, warehouses, commercial retail, reinforcing and modifications
        of existing structures and miscellaneous steel such as stairs, handrail and ladders.`
      ]
    },
    aisc: {
      heading: `aisc affiliation`,
      text: [
        `In March of 2008 Indy Steel Erectors became the 2nd steel erector in Indiana and the 120th in the United States of America
        to achieve AISC (American Institute of Steel Construction) Certified Steel Erector status.`,
        `In April of 2011 we became the 1st erector in Indiana accredited with the AISC Advanced Certified Steel Erector. In 2018 Indy
        Steel Erectors was certified under the new AISC standards with endorsements in seismic and metal decking.`
      ]
    },
    innovators: {
      heading: `innovators in the market place`,
      text: [
        `We have partnered with a national safety consultancy firm developing personal fall arrest systems that have eventually
        became available for public purchase.`,
        `Quality verification has moved to the forefront and is led by GPS, the robotic total station, and individual calibrated tool sets.
        The production focus has come in the way of new crane configurations, new rigging equipment, new techniques, and we have assisted
        in the evolution of new safety equipment and tutorials.`
      ]
    }
  },
  projects: {
    heading: 'Projects',
    caption: {
      butler: 'Butler University Lacy School',
      comlux: 'COMLUX',
      community: 'Community North Cancer Center',
      ikea: 'IKEA',
      whiteRiver: 'White River MOB',
      sunbeam: 'Sunbeam Collapse',
      merchants: 'Merchants Bank Headquarters',
      convergence: 'Discovery Convergence'
    },
    description: {
      butler: [
        `The Butler University Lacy project located in Indianapolis, IN was on the Butler University campus.  The site was extremely tight with existing buildings on two sides. While the east and west sides of the project were tight due to the building restraints, the main road on campus was restricting the north side of this project site. The building was 107,800 square feet and included 673 tons of structural steel and 16 tons of joists.`,
        `The structure had four floors and a roof and was braced with concrete shear towers; field welding rathole moments to the tower.  Two stairs were erected inside the concrete towers prior to the start of erection.   A large monumental stair located in the atrium was installed on two floors. The building’s exterior includes brick relief welded to the pour stop and brick frames.`
      ],
      comlux: [
        `The Comlux structure located at the Indianapolis International Airport was an extremely challenging project. This is due to the tight space of the site, working at
      an existing hanger on the airport, and having to construct 430-foot-long spans.`,
        `The crane lift for the 430-foot plate girders were built on the ground in halves and in tandem pieces.  The north half was hoisted into the air and held with two cranes then the south half was hoisted with two additional cranes and connected while hoisted in the air. We also installed the insulated metal panels and standing seam roof.`
      ],
      community: [
        `The new Community North Cancer Center located in Indianapolis, IN was an addition to the Community North Hospital campus. The 129,400 square foot structure included 922 tons of structural steel and was a field welded rathole moment braced structure.  The structure included two floors and a roof. The miscellaneous steel included three stairs, emergency light supports, and additional railing.`,
        `The exterior of the building had frames for cladding support and roof parapet support steel.  We erected four shop-fabricated box pedestrian connector bridges, which were 105 feet long and weighed 73,000 pounds.  Two of the bridges were installed over a busy road, which were used to connect to the existing hospital.`
      ],
      ikea: [
        `The IKEA store located in Fishers, IN is 294,700 square feet. This project featured 585 tons of structural steel and 631 tons of joists; including several stairs, ladders, handrail and other miscellaneous steel items. The structure had a high roof at 38 feet and low roof at 22 feet elevation.`,
        `The exterior of the building was constructed using girt framing with parapet support while the deck was shot down with Hilti pins. The erection of this project also included IKEA’s three-sided signature sign that was 60-foot-long at 12-foot-tall on all three sides laid atop a 110-foot-tall structure.`
      ],
      whiteRiver: [
        `The White River MOB located in Greenwood, IN is 86,500 square feet. This structure was constructed using 577 tons of structural steel. This project also included two stairs, one monumental stair, and other miscellaneous steel items.`,
        `The structure is three floors and included a roof and lateral framing, which was field welded using moment connections. The building exterior included brick frames on all floors with roof parapet support.`
      ],
      sunbeam: [
        `This was an unbelievable project that you hope to do only once in your career.  Eight bays of the existing structure had collapsed.  We decided to shore the existing building, then demolish the damaged columns, joist girders, joists, and metal roof decking.  The removal of the joists with metal deck and roofing material was a challenge while executing the plan.`,
        `Indy Steel Erectors had to remove the twisted
      steel and joist assemblies over partially collapsed precast panels.  Once everything was demolished, new precast panels were installed along with new columns, joist girders, joists, and roof decking. Check out the video.`
      ],
      sunbeamHyperlinkText: 'Check out the video',
      merchants: [
        `Building the new headquarters for Merchants Bank was challenging because of the tight site located in the Carmel, IN downtown area.  The 132,100 square foot building had 339 tons of steel, 356 tons of joists, and included four floor elevations of steel and roof. The site lay down was extremely small measuring only 25 feet by 125 feet, which eliminated conventional cranes. It was necessary to use a self-erecting tower crane.`,
        `Our site logistics plan was complex starting with the size, type and placement of crane, the small load list so that erection crew downtime did not occur, and traffic control and hoist paths over the existing road since the road had to remain in use. The bracing for this office building was done by field welding diagonal tube steel and the floor structure was joist and joist girders. We installed two stairs, ladders and site railing. the perimeter of the building had some brick relief welded to the pour stop.`
      ],
      convergence: [
        `The Convergence at Discovery Park is an office building located on the Purdue University’s Campus in West Lafayette, IN. The 154,900 square foot structure has 659 tons of steel and 236 tons of joist.`,
        `The structure has four floors of steel as well as a roof structure. The field welded diagonal tube steel bracing makes up the building’s lateral stability. The floor structure was created with carry beams with joists. Miscellaneous parts of the project consisted of two egress stairs, elevator guide posts, and dividers.`
      ]
    }
  },
  safety: {
    heading: 'Safety',
    statement: {
      heading: `Safety Statement`,
      text: [
        `The primary mission of Indy Steel Erectors is to keep our employees safe.
        In order to accomplish this, at a minimum Indy Steel will meet federal and/or state requirements
        for construction safety. Management makes it a priority to provide our employees with safe work sites;
        minimizing hazards and risks associated with our craft.`,
        `Indy Steel Erectors believes safety can be accomplished by providing training,
        proper safety equipment and evaluating of work sites for seen and unforeseen hazards. We promote
        see something say something…together safety can be achieved.`
      ]
    },
    standards: {
      heading: `Safety Standards`,
      text: [
        `Indy Steel Erectors is a member of CCS (Coalition of Construction Safety) and we have an extensive Safety,
        Accident Prevention, and Training program. This includes but is not limited to a new hire safety orientation,
        a drug free work place, policy for disciplinary action, and accident prevention and reporting.`,
        `Each project has a site safety/fall protection plan and site erection plan that is reviewed by our
        management committee and with our foreman and ironworkers prior to the start of the job. In addition to
        these safety standards, we also have weekly tool box talks, quarterly safety meetings with our ironworkers,
        and additional training as required.`
      ]
    }
  },
  quality: {
    heading: 'Quality',
    statement: {
      heading: `QUALITY STATEMENT - RISE ABOVE`,
      text: [
        `A mission of Indy Steel Erectors is to supply the owner with the quality and professionalism
        meeting contract requirements. With this in mind, Management will direct all activities to meet this commitment.`,
        `Indy Steel Erectors has established an ongoing educational training program for key personnel.
        Management direction and educational training will help key employees RISE ABOVE any challenges seen or unforeseen.`
      ]
    },
    standards: {
      heading: `AISC Quality Standard`,
      text: [
        `Indy Steel Erectors is a volunteer participant in the AISC certification program.
        As a member of AISC we accept the required standard placed on us. This AISC standard assures owners that
        Indy Steel Erectors has the personnel, the organization, the experience, the procedures, the knowledge, the equipment
        and the commitment to erect structural and miscellaneous steel to the level of quality required per the AISC standard.`
      ]
    }
  },
  contact: {
    heading: 'Contact Us'
  },
  footer: {
    contact: {
      phone: '317-831-8474',
      email: 'info@indysteelerectors.com'
    },
    address: ['4421 E. N. Country Line Road', 'Camby, Indiana 46113']
  },
  spotlight: {
    title: `Spotlight`,
    project: `Merchants Bank`,
    bodyText: [
      `The new headquarters for Merchants Bank was a challenging project
      because of the small and restricted site located in downtown Carmel, IN.`,
      `The 132,000 square foot building had 339 tons of steel and 356 tons of joist included
      four floor elevations of steel and one roof elevation.`
    ],
    button: `Read More`
  }
};

export default ContextContent;
